import { Check } from "lucide-react";
import type { IssueProgressData } from "@shared-core/domain/issues";
import { deriveIssueProgress } from "@shared-core/domain/issues";

/**
 * The three-step workflow trail (Raised → Investigating → Resolved).
 * Workflow metadata only — shown to every tier, including reporters.
 */
export function IssueProgressTrail({ issue }: { issue: IssueProgressData }) {
  const steps = deriveIssueProgress(issue);

  return (
    <ol className="space-y-0">
      {steps.map((step, i) => {
        const isLast = i === steps.length - 1;
        return (
          <li key={step.key} className="flex gap-3">
            <div className="flex flex-col items-center">
              <span
                className={`flex h-5 w-5 items-center justify-center rounded-full text-white ${
                  step.reached
                    ? step.current && !step.terminal
                      ? "bg-[color:var(--color-primary)]"
                      : "bg-[color:var(--color-success)]"
                    : "bg-muted"
                }`}
              >
                {step.reached && (!step.current || step.terminal) ? (
                  <Check className="h-3 w-3" />
                ) : null}
              </span>
              {!isLast && (
                <span
                  className={`w-px flex-1 min-h-6 ${
                    step.reached
                      ? "bg-[color:var(--color-success)]"
                      : "bg-[color:var(--color-border)]"
                  }`}
                />
              )}
            </div>
            <div className={isLast ? "" : "pb-4"}>
              <div
                className={`text-sm font-medium ${
                  step.reached ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {step.label}
              </div>
              <div className="text-xs text-muted-foreground">
                {step.detail ?? "—"}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
